export default __webpack_public_path__ + "static/media/08.ec4f3c35.jpg";